import { render, staticRenderFns } from "./union.vue?vue&type=template&id=2761a9d3&"
import script from "./union.vue?vue&type=script&lang=js&"
export * from "./union.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports